/* eslint-disable no-case-declarations */
/* eslint-disable indent */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Modal } from 'antd-v5';
import { useInfiniteQuery } from 'react-query';
import { useCallback, useMemo, useState } from 'react';
import { getProductsElasticSearch } from '../../../../api/products';
import { getVendorItems } from '../../../../api/vendors';
import ProductsV2List from '../../../Routes/ProductsV2/components/List';
import { parseVendorProduct } from '../../../Routes/ProductsV2/helpers';

const limit = 20; // number of items displayed in infinite scroll

const ChatProductModalV2 = ({ open, onClose, type, selectProduct, selectVendor, vendors = [] }) => {
  const [search, setSearch] = useState('');
  const [productsPage, setProductsPage] = useState(1);
  const [showBrandDropdown, setShowBrandDropdown] = useState(false);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [searchField, setSearchField] = useState(localStorage.getItem('productsV2SearchField') || 'name');

  const handleClose = () => {
    setSearch('');
    setProductsPage(1);
    setSelectedBrands([]);
    setSelectedCategories([]);
    setShowBrandDropdown(false);
    onClose();
  };

  const isVendorSelected = useMemo(() => {
    return !['product-all', 'product-in-stock'].includes(type);
  }, [type]);

  const title = useMemo(() => {
    if (type === 'product-all') {
      return 'All Products';
    }

    if (type === 'product-in-stock') {
      return 'In Stock';
    }

    const selectedVendor = vendors?.find(vendor => vendor.id.toString() === type.split('-')[1]);

    if (!selectedVendor) {
      return '';
    }

    return selectedVendor.imageUrl || selectedVendor.name;
  }, [vendors, type]);

  const filters = useMemo(() => {
    const filtersObj = {};

    if (!isVendorSelected) {
      if (selectedBrands.length > 0) {
        filtersObj.brand = {
          $in: selectedBrands.map(item => item?.value || item),
        };
      }

      if (selectedCategories.length > 0) {
        filtersObj.category = {
          $in: selectedCategories.map(item => item?.value || item),
        };
      }
    }

    return filtersObj;
  }, [selectedBrands, selectedCategories]);

  const { data, isFetching, fetchNextPage } = useInfiniteQuery(
    ['getProductsElasticSearch', type, search, searchField, filters],
    async ({ pageParam = 1 }) => {
      console.log(type);
      switch (type) {
        case 'product-all':
          const response = await getProductsElasticSearch({
            params: {
              page: pageParam,
              limit,
              hasImage: true,
              search,
              searchField,
              filters: {
                ...filters,
              },
            },
          });
          const formattedImages = response?.data?.data.filter(item => !!item.image);
          return {
            data: formattedImages,
            total: response.data.total,
          };
        case 'product-in-stock':
          const responseInStock = await getProductsElasticSearch({
            params: {
              page: pageParam,
              limit,
              hasImage: true,
              search,
              searchField,
              filters: {
                available: true,
                ...filters,
              },
            },
          });
          const formattedImagesInStock = responseInStock.data.data.filter(item => !!item.image);
          return {
            data: formattedImagesInStock,
            total: responseInStock.data.total,
          };
        default:
          if (type.includes('brands')) {
            const vendorId = type.split('-')[1];
            if (!vendorId) return;
            const res = await getVendorItems(vendorId, {
              params: {
                page: pageParam,
                limit,
                search,
              },
            });
            return {
              data: res.data.data.map(parseVendorProduct),
              total: res.data.total,
            };
          }
          return {
            data: [],
            total: 0,
          };
      }
    },
    {
      enabled: open,
      onError: err => {
        console.error(err);
      },
      onSuccess: res => {
        console.log(res);
      },
      refetchOnWindowFocus: false,
      initialData: {
        data: [],
        total: 0,
      },
      //keepPreviousData: true,
      getNextPageParam: (pages, ...rest) => {
        const add = rest.length ? rest[0].length : 0;
        return add + 1;
      },
    },
  );

  const nextData = useCallback(
    newPage => {
      setProductsPage(newPage);
      fetchNextPage();
    },
    [fetchNextPage],
  );

  const products = useMemo(() => {
    if (!data) return [];
    if (data?.pages?.length === 0) return [];
    const allProducts = data?.pages?.reduce((acc, page) => {
      return [...acc, ...page.data];
    }, []);
    return allProducts;
  }, [data, type]);

  const productsTotal = useMemo(() => {
    if (!data || data?.length === 0) return 0;
    if (data?.pages?.length === 0 || !data?.pages) return 0;
    const total = data?.pages[0]?.total || 0;
    return total;
  }, [data, type]);

  const handleSelect = useCallback(
    id => {
      if (type.includes('brands')) {
        const selectedVendorItem = products.find(product => product.id === id);
        if (selectedVendorItem) {
          selectVendor(selectedVendorItem);
          handleClose();
        }
      } else {
        const selectedProduct = products.find(product => product.id === id);
        if (selectedProduct) {
          selectProduct(selectedProduct);
          handleClose();
        }
      }
    },
    [type, products],
  );

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      onOk={handleClose}
      destroyOnClose
      centered
      footer={null}
      styles={{
        body: {
          maxHeight: '700px',
          minHeight: '500px',
          overflow: 'hidden', // Prevent body from scrolling
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      {/* <Input.Search
        placeholder="Search by name or item number"
        onChange={e => setSearch(e.target.value)}
        value={search}
      />
      <p
        style={{
          color: '#818181',
          fontSize: '12px',
          fontStyle: 'italic',
          marginTop: '10px',
        }}
      >
        Only showing products with images
      </p>
      <div
        style={{
          flex: 1,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <List
          rowKey={item => item.id}
          loading={isFetching}
          dataSource={data?.data || []}
          itemLayout="horizontal"
          renderItem={item => <ProductItem {...item} onSelect={() => handleSelectProduct(item)} />}
          style={{
            height: '400px', // Fixed height for scrolling
            overflowY: 'auto',
            overflowX: 'hidden',
            paddingRight: '16px',
          }}
        />
      </div> */}
      <ProductsV2List
        title={title}
        productsLoading={isFetching}
        products={products}
        productsSearch={search}
        setProductsSearch={setSearch}
        searchField={searchField}
        setSearchField={setSearchField}
        productsPage={productsPage}
        productsTotal={productsTotal}
        setProductsPage={nextData}
        setSelectedProductId={handleSelect}
        isVendorSelected={isVendorSelected}
        showBrandDropdown={showBrandDropdown}
        setShowBrandDropdown={setShowBrandDropdown}
        selectedBrands={selectedBrands}
        setSelectedBrands={setSelectedBrands}
        selectedCategories={selectedCategories}
        setSelectedCategories={setSelectedCategories}
        width="100%"
        padding="0px"
        borderRight="none"
        hasImage
      />
    </Modal>
  );
};

export default ChatProductModalV2;
